"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CycleType = void 0;
var _moment = _interopRequireDefault(require("moment"));
const CycleType = exports.CycleType = {
  Year: 'year',
  Month: 'month',
  Date: 'date'
};
const FormatType = {
  year: 'YYYY',
  month: 'YYYY-MM',
  date: 'YYYY-MM-DD'
};
const dateTypeList = [{
  value: CycleType.Year,
  name: '年'
}, {
  value: CycleType.Month,
  name: '月'
}, {
  value: CycleType.Date,
  name: '日'
}];
var _default = exports.default = {
  props: {
    value: {
      type: String,
      default: undefined
    },
    defaultRadioValue: {
      type: String
    },
    dateTypeList: {
      type: Array,
      default: () => dateTypeList
    },
    allowClear: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: false,
      currentDateType: CycleType.Date,
      CycleType
    };
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(value) {
        if (value) {
          value = (0, _moment.default)(value).format(this.format);
        }
        this.$emit('input', value);
        this.$emit('change', {
          value,
          cycleType: this.currentDateType
        });
      }
    },
    format() {
      return FormatType[this.currentDateType];
    }
  },
  created() {
    if (this.defaultRadioValue) {
      this.currentDateType = this.defaultRadioValue;
    }
  },
  methods: {
    toggleOpen() {
      this.open = !this.open;
    },
    handleStartOpenChange(open) {
      this.open = open;
    },
    async handlePanelChange(value) {
      this.modelValue = value;
      this.open = false;
    },
    radioChange(e) {
      this.currentDateType = e.target.value;
      if (this.modelValue) {
        this.modelValue = (0, _moment.default)(this.modelValue).format(this.format);
      }
    }
  }
};